import { css } from '@emotion/react';
import { theme } from '../../../../theme';

const { primary, background, secondary } = theme.palette;

const slidernationWrapper = css`
  display: flex;
  gap: 5px;
`;

const slidernationTab = css`
  width: 16px;
  background: white;
  transition: background 0.25s ease;
  border: none;
  border-radius: 2.5px;
  height: 5px;
  border: 1px solid ${primary.main};

  &[data-active='true'] {
    background: ${primary.main};
  }
`;

const greenTabs = css`
  border: 1px solid ${secondary.dark};
  background: ${background.gray};

  &[data-active='true'] {
    background: ${secondary.dark};
  }
`;

const buttonStyle = css`
  padding: 8px 2px;
  margin: 0;
  border: none;
  cursor: pointer;
  background: transparent;
`;

export { slidernationWrapper, slidernationTab, greenTabs, buttonStyle };
